module.exports = __webpack_public_path__ + "media/svg-new/button-left-blue-ce72cba3.svg";